import { DEFAULT_WATCHLIST_SYMBOLS } from "./default-data";

const STORAGE_KEY = "symbols-watchlist";

export const saveWatchlistToStorage = (watchlist: string[]): void => {
  try {
    if (typeof window !== "undefined" && window.localStorage) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(watchlist));
    }
  } catch (error) {
    console.error("Failed to save watchlist to localStorage:", error);
  }
};

export const loadWatchlistFromStorage = (): string[] => {
  try {
    if (typeof window !== "undefined" && window.localStorage) {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) {
        const parsed = JSON.parse(stored);
        if (Array.isArray(parsed)) {
          return parsed.filter(item => typeof item === "string");
        }
      }
    }
  } catch (error) {
    console.error("Failed to load watchlist from localStorage:", error);
  }
  return DEFAULT_WATCHLIST_SYMBOLS;
};

export const clearWatchlistStorage = (): void => {
  try {
    if (typeof window !== "undefined" && window.localStorage) {
      localStorage.removeItem(STORAGE_KEY);
    }
  } catch (error) {
    console.error("Failed to clear watchlist from localStorage:", error);
  }
};
